import type { ICellRendererParams } from 'ag-grid-community';
import { MdArticle, MdPlayCircleOutline } from 'react-icons/md';
import type { IconType } from 'react-icons';
import type { NewsArticle, NewsArticleKind } from '../../schema';

// Tonal pill — same visual language as StatusBadge so editors immediately
// read this as a discrete category, not free text. Icon prefix reinforces
// the type at a glance even before reading the label.
const STYLES: Record<
  NewsArticleKind,
  { label: string; bg: string; text: string; icon: IconType }
> = {
  article: {
    label: 'Article',
    bg: 'bg-primary/[0.10]',
    text: 'text-primary',
    icon: MdArticle,
  },
  video: {
    label: 'Video',
    bg: 'bg-secondary/15',
    text: 'text-secondary',
    icon: MdPlayCircleOutline,
  },
};

export function KindCell(p: ICellRendererParams<NewsArticle, NewsArticleKind>) {
  const kind = p.value;
  if (!kind) return null;
  const s = STYLES[kind];
  const Icon = s.icon;
  return (
    <span
      className={[
        'inline-flex w-fit shrink-0 items-center gap-1 self-center rounded-full px-2 py-[3px]',
        'text-[10.5px] font-bold uppercase leading-none tracking-wider',
        s.bg,
        s.text,
      ].join(' ')}
    >
      <Icon size={12} aria-hidden />
      <span>{s.label}</span>
    </span>
  );
}
